export const CHECKOUT_PAY_ROUTE = '/checkout/:invoiceId/pay';
export const CHECKOUT_SUCCESS_ROUTE = '/checkout/:invoiceId/success';
export const CHECKOUT_CANCEL_ROUTE = '/checkout/:invoiceId/cancel';
export const CARD_ADDED_SUCCESS_ROUTE = '/card-added/success';

export const getCheckoutPayUrl = (invoiceId: string) =>
    `/checkout/${invoiceId}/pay`;
export const getCheckoutSuccessUrl = (invoiceId: string) =>
    `/checkout/${invoiceId}/success`;
export const getCheckoutCancelUrl = (invoiceId: string) =>
    `/checkout/${invoiceId}/cancel`;